"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function StartChangeToday() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  const {
    ref: btnRef,
    isVisible: isBtnVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  return <section data-section-id="104221" id="randevu-al" className="bg-secondary text-foreground relative overflow-hidden py-24 md:py-32 lg:py-40">
      {}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1617553/img/gritty_dark_gym_texture.png)] bg-cover bg-center opacity-10 mix-blend-multiply"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-secondary via-secondary/95 to-background/40"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10 flex flex-col md:flex-row items-center justify-between gap-12 md:gap-8">
        {}
        <div ref={textRef} className={`flex-1 text-center md:text-left transition-all duration-1000 ease-out transform ${isTextVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
          <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-serif font-light uppercase tracking-tight leading-[1.1] text-foreground drop-shadow-sm">
            Hayalinizdeki <br className="hidden md:block" />
            Gülüşe Bir <br className="hidden md:block" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-primary/70">
              Adım Kaldı
            </span>
          </h2>
        </div>

        {}
        <div ref={btnRef} className={`flex-shrink-0 transition-all duration-1000 ease-out delay-200 transform ${isBtnVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
          <Button asChild className="border-2 border-primary text-primary bg-transparent hover:bg-primary hover:text-primary-foreground rounded-sm h-auto py-6 px-10 sm:py-8 sm:px-14 text-xl sm:text-2xl lg:text-3xl font-serif font-medium uppercase tracking-widest transition-all duration-500 ease-in-out hover:scale-105 hover:shadow-xl">
            <Link to="/ContactPage">Randevu Al</Link>
          </Button>
        </div>
      </div>
    </section>;
}